import {
  Timestamp,
  arrayUnion,
  doc,
  addDoc,
  onSnapshot,
  serverTimestamp,
  updateDoc,
  query,
  where,
  collection,
  setDoc,
} from "firebase/firestore";
import { db } from "../firebase";
import moment from "moment/moment";
import { customOrderByASC, customOrderByDESC } from "./helper";

const tableName = "actions";

export const getActionsInRealTime = (id, cb) => {
  return onSnapshot(
    query(collection(db, tableName), where("reportId", "==", id)),
    (doc) => {
      const dataSnaps = [];
      doc.forEach((each) => {
        const temp = each.data();
        const object = {
          ...temp,
          temp: temp.timestamp.seconds,
        };
        dataSnaps.push(object);
      });
      cb(customOrderByDESC(dataSnaps));
    }
  );
};

export const getConsolidatedActionsInRealTime = (ids, cb) => {
  if (!ids.length) { cb([]); return () => {}; }

  // Firestore 'in' operator supports max 30 values — batch if needed
  const batches = [];
  for (let i = 0; i < ids.length; i += 30) {
    batches.push(ids.slice(i, i + 30));
  }

  const batchResults = new Map();
  const unsubs = batches.map((batchIds, batchIdx) =>
    onSnapshot(
      query(collection(db, tableName), where("reportId", "in", batchIds)),
      (snap) => {
        const items = [];
        snap.forEach((each) => {
          const temp = each.data();
          items.push({ ...temp, temp: temp.timestamp.seconds });
        });
        batchResults.set(batchIdx, items);
        // Merge all batch results and emit
        const merged = [];
        batchResults.forEach((v) => merged.push(...v));
        cb(customOrderByDESC(merged));
      }
    )
  );

  return () => unsubs.forEach((u) => u?.());
};

export const createAction = (action, communityCode, reportId) => {
  const { selfId } = action;
  return setDoc(doc(db, tableName, selfId), {
    id: selfId,
    communityCode,
    reportId,
    timestamp: Timestamp.now(),
    ...action,
  });
};

export const updateAction = (actionId, changes) => {
  return updateDoc(doc(db, tableName, actionId), changes);
};

